import auth from './auth'
import permission from './permission'
export default {
    auth, permission
}